<script setup lang="ts">
import PiIcon from '@uiKit/elements/PiIcon.vue'
</script>

<template>
  <div class="fca__circle">
    <PiIcon name="times" class="fca__icon" />
  </div>
</template>

<style scoped>
.fca__circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--p-danger-50) 0%, var(--p-danger-100) 100%);
  border: 2px solid var(--p-danger-200);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  animation: fca-pop 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.05s both;
}

.fca__circle::before,
.fca__circle::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid var(--p-danger-200);
  animation: fca-ripple 1.8s ease-out 0.3s infinite;
}

.fca__circle::after {
  animation-delay: 0.75s;
}

.fca__icon {
  font-size: 1.75rem;
  color: var(--p-danger-500);
  position: relative;
  z-index: 1;
}

@keyframes fca-pop {
  0% {
    transform: scale(0.4);
    opacity: 0;
  }
  60% {
    transform: scale(1.15);
    opacity: 1;
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes fca-ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
